import moment, { Moment } from 'moment'
import qs from 'qs'

import { TypeFormats } from 'utils/format'

import { ITimePeriod } from './types'

const compareSameTimePeriods =
  (timePeriodA: ITimePeriod, timePeriodB: ITimePeriod) =>
  (key: keyof ITimePeriod): boolean =>
    timePeriodA !== null &&
    timePeriodB !== null &&
    timePeriodA[key].isSame(timePeriodB[key])

export const areSameTimePeriods = (
  timePeriodA: ITimePeriod,
  timePeriodB: ITimePeriod
): boolean => {
  const isSame = compareSameTimePeriods(timePeriodA, timePeriodB)
  return (
    isSame('startDate') &&
    isSame('endDate') &&
    isSame('prevStart') &&
    isSame('prevEnd')
  )
}

export const calculateTimePeriod = (
  start: Moment,
  end: Moment
): ITimePeriod => {
  const startDate = moment(TypeFormats.DATE(start))
  const endDate = moment(TypeFormats.DATE(end))
  const diff = moment(endDate).diff(startDate, 'days')
  return {
    startDate,
    endDate,
    prevStart: moment(startDate).subtract(1 + diff, 'days'),
    prevEnd: moment(startDate).subtract(1, 'day'),
  }
}

export const calculateLastSevenDaysTimePeriod = (): ITimePeriod =>
  calculateTimePeriod(moment().subtract(7, 'days'), moment())

export const getFilterQueryString = (timePeriod: ITimePeriod) => {
  const dates = {
    startDate: TypeFormats.DATE(timePeriod.startDate.format()),
    endDate: TypeFormats.DATE(timePeriod.endDate.format()),
  }

  return qs.stringify(dates, { addQueryPrefix: true })
}
